import { getPipelineByName } from "./getPipelineByName.js";
export const getPipelineStageId = async ({ pipelineName, stageName }, { client }) => {
    const pipeline = await getPipelineByName({ pipelineName }, { client });
    return pipeline.stages?.find((stage) => stage.name === stageName)?.id;
};
